import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { Button, Pagination } from 'antd';
import React from 'react';
import { MAX_ELASTICSEARCH_RESULTS } from '~/helpers/catalogue';

import './CustomPagination.scss';

const mapTypeToComponent = {
  prev: {
    type: 'icon',
    component: <LeftOutlined />,
  },
  next: {
    type: 'icon',
    component: <RightOutlined />,
  },
  'jump-prev': {
    type: 'text',
    component: '...',
  },
  'jump-next': {
    type: 'text',
    component: '...',
  },
};

function CustomPagination(props) {
  const { current, pageSize, total, onChange, isDeepPagination = false, ...remainingProps } = props;

  // Check if we're in deep pagination mode
  const useDeepPagination = isDeepPagination || current * pageSize >= MAX_ELASTICSEARCH_RESULTS;
  const totalItems = total > MAX_ELASTICSEARCH_RESULTS ? (useDeepPagination ? current * pageSize + pageSize : MAX_ELASTICSEARCH_RESULTS) : total;

  // Check if we have a next page token
  const renderPaginationItems = (page, type) => {
    if (useDeepPagination && page !== current && type !== 'prev' && type !== 'next') {
      return null;
    }
    if (type !== 'page') {
      return (
        <Button type='text' size='large' className='btn-icon' icon={mapTypeToComponent[type]?.type === 'icon' ? mapTypeToComponent[type].component : null}>
          {mapTypeToComponent[type]?.type === 'text' ? mapTypeToComponent[type].component : null}
        </Button>
      );
    }
    return (
      <Button type={current === page ? 'default' : 'text'} className='btn-icon'>
        {page}
      </Button>
    );
  };

  return (
    <Pagination
      {...remainingProps}
      current={current}
      pageSize={pageSize}
      total={totalItems}
      onChange={onChange}
      className={`${props.className ? `${props.className} ` : ''}custom-pagination`}
      itemRender={renderPaginationItems}
    />
  );
}

export default CustomPagination;
